import styled from 'styled-components';
import { TableRowMixin } from '../../mixins/components/TableRowMixin';
export var StyledTableRow = /*#__PURE__*/styled.tr.withConfig({
  displayName: "StyledTableRow",
  componentId: "c11n-8-107-0__sc-65t1u6-0"
})(["", ""], TableRowMixin);